import { render, staticRenderFns } from "./familial.vue?vue&type=template&id=6ff7f17c&"
import script from "./familial.vue?vue&type=script&lang=js&"
export * from "./familial.vue?vue&type=script&lang=js&"
import style0 from "./familial.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports